import React, { useEffect, useState } from "react";
import style from "./index.module.css";
import { getFavoriteProducts, removeFromFavorite } from "../../services/FavoriService";
import { addToBasket } from "../../services/BasketService";

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFavoriteProducts = async () => {
      try {
        const data = await getFavoriteProducts();
        console.log(data);
        
        setProducts(data);
      } catch (error) {
        console.error("Error fetching favorite products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFavoriteProducts();
  }, []);

  const handleRemoveFavorite = async (productId) => {
    console.log(productId);
    
    try {
      const userId = localStorage.getItem("userId"); 
      if (!userId) {
        console.error("User ID is missing");
        return;
      }

     const res= await removeFromFavorite(productId);
     console.log(res);
     
      setProducts((prevProducts) => prevProducts.filter((product) => product.productID !== productId));
    } catch (error) {
      console.error("Failed to remove favorite:", error);
    }
  };

 const handleAddToBasket = async (id)=> {
  try{
    await addToBasket(id,1);
  }
  catch(error){
    console.error("Error adding product to basket: ",error);
  }
 };
  if (loading) {
    return <p>Loading products...</p>;
  }

  return (
    <div>
      <div className={style.wish}>
        <h3>My Wish List on eTrade</h3>
        <div className={style.wish1}>
          <p className={style.pr}>Product</p>
          <p className={style.unit}>Unit Price</p>
          <p>In Stock</p>
        </div>
        {products.length === 0 ? (
          <p>You have no favorite products.</p>
        ) : (
          products.map((product) => (
            <div className={style.product} key={product.id}>
              <div className={style.div1}>
                <button onClick={() => handleRemoveFavorite(product.productID)}>x</button>
                
              </div>
              <div className={style.div2}>
                <div className={style.img}>
                  <img src={product?.productPhoto}  alt={product.productName} />
                </div>
                <div className={style.text}>
                  <p>{product.productName}</p>
                </div>
              </div>
              <div className={style.div3}>
                <p>${product.productPrice}</p>
              </div>
              <div className={style.div4}>
                <p>In Stock</p>
              </div>
              <div className={style.div5}>
                <button onClick={()=> handleAddToBasket(product.productID)}>Add To Card</button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ProductList;
